if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Slick slider initialization for main and thumbnail images
const mainSlider = $('.js-product-mainImage').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  draggable: false,
  arrows: false,
  asNavFor: '.js-product-thumbImage',
  prevArrow: "<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0607/8719/6128/files/left-arrow-svgrepo-com_1.svg'/></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0607/8719/6128/files/right-arrow-svgrepo-com.svg'/></button>"
});

const thumbnailSlider = $('.js-product-thumbImage').slick({
  slidesToShow: 8,
  arrows: false,
  infinite: false,
  centerMode: true,
  asNavFor: '.js-product-mainImage',
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6
      }
    }
  ]
});

// Directly expand all variant accordions without making them toggleable
var acc = document.getElementsByClassName("variant_accordion");
for (var i = 0; i < acc.length; i++) {
  var panel = acc[i].nextElementSibling;
  if (panel) {
    panel.style.maxHeight = panel.scrollHeight + "px";
    panel.style.visibility = "visible";
  }
}

// Shared helper: repaint the visible current price for the selected variant, in
// BOTH the regular and on-sale price layouts (on-sale products show the active
// price in .price-item--sale while .price-item--regular is hidden by CSS), then
// re-render Shopify's full price block via the Section Rendering API so the
// struck-through compare-at price, sale badge and market currency stay correct.
function nmUpdateVariantPrice(price, variantId) {
  if (price != null) {
    $('.product__info-wrapper .price__regular .price-item--regular, .product__info-wrapper .price__sale .price-item--sale').text(price);
  }
  var priceEl = document.querySelector('[id^="price-"]');
  if (!priceEl || !variantId) return;
  var params = new URLSearchParams(window.location.search);
  params.set('variant', variantId);
  params.set('section_id', priceEl.id.replace(/^price-/, ''));
  fetch(window.location.pathname + '?' + params.toString())
    .then(function (response) { return response.text(); })
    .then(function (responseText) {
      var source = new DOMParser()
        .parseFromString(responseText, 'text/html')
        .getElementById(priceEl.id);
      if (source) priceEl.innerHTML = source.innerHTML;
    })
    .catch(function () { /* keep optimistic price on network failure */ });
}

// Variant selection logic
$(document).on("click", ".variant__box", function(e) {
  let id = $(this).data('id');
  let color = $(this).data('title');
  let price = $(this).data('price');
  var substring = $(this).data('material');

  // Optimistic update of the visible current price. On-sale products show the
  // active price in .price__sale .price-item--sale (the .price__regular block is
  // hidden by CSS), so update both layouts — not just .price-item--regular.
  $('.product__info-wrapper .price__regular .price-item--regular, .product__info-wrapper .price__sale .price-item--sale').text(price);

  $('.variant__box').removeClass('active');
  $(this).addClass('active');
  $('.js-pdp-form-id').val(id);
  $('.product__thumbnails[alt="' + color + '"]').click();

  // Re-render the full price block from Shopify for the selected variant so the
  // struck-through compare-at price, sale badge and market currency stay correct.
  var $variantRadios = $(this).closest('variant-radios');
  var priceSection = $variantRadios.data('section');
  var priceUrl = $variantRadios.data('url');
  if (priceSection && priceUrl) {
    fetch(priceUrl + '?variant=' + id + '&section_id=' + priceSection)
      .then(function (response) { return response.text(); })
      .then(function (responseText) {
        var priceId = 'price-' + priceSection;
        var doc = new DOMParser().parseFromString(responseText, 'text/html');
        var source = doc.getElementById(priceId);
        var destination = document.getElementById(priceId);
        if (source && destination) destination.innerHTML = source.innerHTML;
      })
      .catch(function () { /* keep optimistic price on network failure */ });
  }

  document.querySelectorAll('.js-media-slide').forEach((item) => {
    var string = item.getAttribute('alt');
    if (string.indexOf(substring) !== -1) {
      item.classList.remove('hidden');
    } else {
      item.classList.add('hidden');
    }
  });
});

$(document).on("click touchend", ".variants-picker__material", function(e) {
  let id = $(this).data('variantId');
  let color = $(this).data('title');
  let price = $(this).data('price');
  let substring = $(this).data('material');
  let value = $(this).text().trim();
  const sku = $(this).data('sku');

  $('.product__info-wrapper .product-sku > span').text(sku);
  $('.variants-picker__variants-color').addClass('hidden');
  $('.variants-picker__variants-color').filter(function() {
    return String($(this).data('materialValue')).trim() === value;
  }).removeClass('hidden');
  $(`.variants-picker__color`)?.removeClass('selected');
  $(`.variants-picker__color[data-variant-id="${id}"]`)?.addClass('selected');


  nmUpdateVariantPrice(price, id);
  $('.variants-picker__material')?.removeClass('selected');
  $(this).addClass('selected');
  $('.js-pdp-form-id').val(id);
  $('.product__thumbnails[alt="' + color + '"]').click();

  document.querySelectorAll('.js-media-slide').forEach((item) => {
    var string = item.getAttribute('alt');
    if (string.indexOf(substring) !== -1) {
      item.classList.remove('hidden');
    } else {
      item.classList.add('hidden');
    }
  });
});

$(document).on("click touchend", ".variants-picker__color", function(e) {
  let id = $(this).data('variantId');
  let color = $(this).data('title');
  let price = $(this).data('price');
  const substring = $(this).data('material');
  const sku = $(this).data('sku');

  $('.product__info-wrapper .product-sku > span').text(sku);
  nmUpdateVariantPrice(price, id);
  $('.variants-picker__color').removeClass('selected');
  $(this).addClass('selected');
  $('.js-pdp-form-id').val(id);
  $('.product__thumbnails[alt="' + color + '"]').click();

  document.querySelectorAll('.js-media-slide').forEach((item) => {
    var string = item.getAttribute('alt');
    if (string.indexOf(substring) !== -1) {
      item.classList.remove('hidden');
    } else {
      item.classList.add('hidden');
    }
  });
});

$('.variants-picker-tooltip__close').click((e) => {
    const target = e.delegateTarget.closest('.variants-picker-tooltip');
    if (target) {
        target.classList.remove('variants-picker-tooltip_hover')
        target.classList.remove('variants-picker-tooltip_active')
    }
});

$(document).click(function(event) {
    if (!$(event.target).closest('.variants-picker__info-button').length &&
        !$(event.target).closest('.variants-picker-tooltip_active').length) {
        $('.variants-picker-tooltip').removeClass('variants-picker-tooltip_active');
    }
});

$('.variants-picker__info-button').click(() => {
    const selectedPicker = document.querySelector('.variants-picker__color[data-variant-id].selected');

    if (selectedPicker) {
        const tooltip = document.querySelector(`.variants-picker-tooltip[data-variant-id="${selectedPicker.dataset.variantId}"]`);
        tooltip?.classList.add('variants-picker-tooltip_active');
    }
})

$('.variants-picker__picker').mouseenter((e) => {
    // The hover detail card only carries meaningful content for real Color
    // swatches. Suppress it for Finish / Material / Size rows so options like
    // "Finish" don't pop an empty swatch image on hover.
    const row = e.delegateTarget.closest('.variants-picker__row');
    const label = row && row.querySelector('.variants-picker__label')
        ? row.querySelector('.variants-picker__label').textContent
        : '';
    if (!/colou?r/i.test(label)) return;

    const id = e.delegateTarget.dataset.variantId;
    $(`.variants-picker-tooltip[data-variant-id="${id}"]`).addClass('variants-picker-tooltip_hover')
})

$('.variants-picker__picker').mouseleave((e) => {
    const id = e.delegateTarget.dataset.variantId;
    $(`.variants-picker-tooltip[data-variant-id="${id}"]`).removeClass('variants-picker-tooltip_hover')
});

$('.js-popup-trigger').click((e) => {
    const popupId = e.delegateTarget.dataset.popup;
    const popup = document.querySelector(`.js-popup[data-popup="${popupId}"]`);

    if (popup) {
        popup.classList.add('open');
        document.body.classList.add('disable-scroll');
    }
});

$('.js-popup-close,.product-info-modal__overlay').click((e) => {
    const wrapper = e.delegateTarget.closest('.js-popup');

    if (wrapper) {
        wrapper.classList.remove('open');
        document.body.classList.remove('disable-scroll');
    }
});

// Customize show/hide variants
document.addEventListener('DOMContentLoaded', function() {

    function isMobileDevice() {
        var isMobile = window.matchMedia("(max-width: 767px)").matches;
        return isMobile;
    }

    function scrollToVariantsWrapper() {
        if (isMobileDevice()) {
            const variantsWrapper = document.querySelector('#variants_wrapper');
            if (variantsWrapper) {
                variantsWrapper.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }

    function scrollToMainContent() {
        if (isMobileDevice()) {
            const mainContent = document.querySelector('#MainContent');
            if (mainContent) {
                mainContent.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }
  
if(document.getElementById('available-button')){
    document.getElementById('available-button').addEventListener('click', function() {
        document.querySelectorAll('.shipping_wrapper, .product_metafields_shown, .quantity_mobile, .product-form__input .quantity, #ProductInfo-template--16822036267232__main .product__title, #ProductInfo-template--16822036267232__main #shopify-block-58386e5f-a502-420f-be97-7b07304c8168, #ProductInfo-template--16822036267232__main #price-template--16822036267232__main, .product-form__buttons, .shipping-info, .product__description').forEach(function(element) {
            element.style.display = 'none';
        });

        var doneButton = document.querySelector('#done-customizing-button');
        if (doneButton) {
            doneButton.style.display = 'block';
        }

        document.querySelectorAll('.in_stock_variants').forEach(element => {
            element.style.display = 'block';
        });
        document.querySelectorAll('.out_of_stock_variants').forEach(element => {
            element.style.display = 'none';
        });

        scrollToVariantsWrapper();
    });
}
  
if(document.getElementById('made-to-order-button')){
   document.getElementById('made-to-order-button').addEventListener('click', function() {
        document.querySelectorAll('.shipping_wrapper, .product_metafields_shown, .quantity_mobile, .product-form__input .quantity, #ProductInfo-template--16822036267232__main .product__title, #ProductInfo-template--16822036267232__main #shopify-block-58386e5f-a502-420f-be97-7b07304c8168, #ProductInfo-template--16822036267232__main #price-template--16822036267232__main, .product-form__buttons, .shipping-info, .product__description').forEach(function(element) {
            element.style.display = 'none';
        });

        var doneButton = document.querySelector('#done-customizing-button');
        if (doneButton) {
            doneButton.style.display = 'block';
        }

        document.querySelectorAll('.out_of_stock_variants').forEach(element => {
            element.style.display = 'block';
        });
        document.querySelectorAll('.in_stock_variants').forEach(element => {
            element.style.display = 'none';
        });

        scrollToVariantsWrapper();
    });

}
   
    var doneButton = document.querySelector('#done-customizing-button');
    if (doneButton) {
        doneButton.addEventListener('click', function() {
            document.querySelectorAll('.shipping_wrapper, .product_metafields_shown, .quantity_mobile, .product-form__input .quantity, #ProductInfo-template--16822036267232__main .product__title, #ProductInfo-template--16822036267232__main #shopify-block-58386e5f-a502-420f-be97-7b07304c8168, #ProductInfo-template--16822036267232__main #price-template--16822036267232__main, .product-form__buttons, .shipping-info, .product__description').forEach(function(element) {
                element.style.display = '';
            });

            doneButton.style.display = 'none';

            document.querySelectorAll('.in_stock_variants, .out_of_stock_variants').forEach(element => {
                element.style.display = 'none';
            });

            scrollToMainContent();
        });
    }
});

